import { useLocaleKeys } from '~/i18n';
export const useDraftsChipConnector = ()=>{
    const { t } = useLocaleKeys('proposal.draftsDashboard.aiSearch');
    return {
        labels: {
            and: t.andConnector(),
            or: t.orConnector()
        },
        toggleBiName: 'drafts_ai_search_toggle_connector'
    };
};
